const React = require("react");

function GoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.85,10.17h-9.62v3.89h5.44c-0.33,1.31-1.02,2.33-2.11,2.96c-0.89,0.54-2.04,0.81-3.5,0.81c-2.59,0-4.79-1.68-5.57-4.03 c-0.18-0.57-0.3-1.18-0.3-1.83c0-0.63,0.09-1.24,0.3-1.81C7.25,7.8,9.46,6.1,12.06,6.1c1.48,0,2.83,0.48,3.87,1.35l2.96-2.9 c-1.79-1.61-4.22-2.52-6.9-2.52c-3.74,0-7.25,2.28-8.94,5.59C2.39,8.93,2,10.41,2,11.96c0,1.61,0.37,3.13,1.05,4.48 c1.65,3.27,5.03,5.53,8.94,5.53c2.65,0,5.05-0.87,6.83-2.46C20.78,17.79,22,15.2,22,11.96C22,11.33,21.94,10.74,21.85,10.17z"
  }));
}

module.exports = GoogleIcon;